import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTendersTenderAttachments } from '~src/services/api';
import { DbAttachment, DbFile } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';
import { QueryKeys } from './queryKeys';

interface UseTenderFoldersSttachmentsParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
  tender_id?: string;
}
export const useTendersTenderAttachments = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
    tender_id,
  }: UseTenderFoldersSttachmentsParams = {},
  queryConfig: QueryConfig<DbAttachment[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const archiveSettings = useArchiveSettings();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on;

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<DbAttachment[], AxiosError>(
    [
      QueryKeys.tendersTenderAttachments,
      {
        projectId: String(projectId),
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
        tender_id,
      },
    ],
    loadTendersTenderAttachments,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId && isTenderingOn,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
